import React from 'react';
import {Link} from "react-router-dom";

// import {BiLastPage} from "react-icons/bi";
// import {BsInfoCircle} from "react-icons/bs";
import {MdOutlineExpandMore, MdOutlineExpandLess} from "react-icons/md";


import "../../../style/PriorityTableStyles/welcomeText.css";

export default function WelcomeText() {
    // const [isWelcomeTextOpen, setIsWelcomeTextOpen] = React.useState(true);

    const [moreInfoHeadlinesIsOpen, setMoreInfoHeadlinesIsOpen] = React.useState<MoreInfoHeadlinesIsOpen>({
        publishNotes: false,
        partialPublishing: false,
        help: false,
    });

    // const handleToggleWelcomeText = () => {
    //     setIsWelcomeTextOpen(!isWelcomeTextOpen);
    // }

    const toggleMoreInfoHeadline = (headline: keyof MoreInfoHeadlinesIsOpen) => {
        setMoreInfoHeadlinesIsOpen((prevState) => ({
            ...prevState,
            [headline]: !prevState[headline],
        }));
    }

    return (
        <div className="welcome-text-container">
            <h1 className="welcome-headline text-2xl font-semibold">Velkommen til forfatterportalen</h1>

            {/*<button className="close-welcome-text-button" onClick={() => {*/}
            {/*    handleToggleWelcomeText()*/}
            {/*}}>{isWelcomeTextOpen ? <BiLastPage style={{transform: 'rotate(270deg)'}}/> : <BsInfoCircle/>}*/}
            {/*</button>*/}

            <div
                className="welcome-text-box"
            >
                <p className="welcome-text-paragraph">I denne forfatterportalen kan du ajourføre lovkommentarene dine.
                    Under finner du en oversikt over
                    oppgavene dine.
                </p>
                <p className="welcome-text-paragraph">Oversikten kan inneholde flere oppgaver til samme publikasjon.
                    Eksempelvis fordi noen noter i en lovkommentar er berørt av lovendringer, mens andre noter i samme
                    lovkommentar må gjennomgås og bekreftes à jour.
                </p>
                <div className="more-info-container">
                    <h1 className="text-xl font-semibold mb-10">Mer om hvordan du går frem</h1>
                    <button className="more-info-headline" onClick={() => {
                        toggleMoreInfoHeadline('publishNotes')
                    }}>
                        <div>Legge til eller endre noe i publiserte noter?</div>
                        {moreInfoHeadlinesIsOpen.publishNotes ?
                            <MdOutlineExpandLess className="more-info-icons"/> :
                            <MdOutlineExpandMore className="more-info-icons"/>
                        }
                    </button>
                    <div
                        className={
                            `more-info-paragraph-container${moreInfoHeadlinesIsOpen.publishNotes ? ' expanded' : ''}`
                        }
                    >
                        <p className="more-info-paragraph">Ta kontakt med support (
                            <Link className="welcome-text-link" to="mailto:support@karnovgroup.no"
                                  target="_blank">support@karnovgroup.no</Link>
                            ) hvis du ønsker å legge til eller endre noe i de publiserte notene dine, men ikke finner en
                            aktiv oppgave i listen.</p>
                        <p className="more-info-paragraph">Revisjonsmanus for årlig gjennomgang av publiserte noter kan
                            du også opprette selv. </p>
                        <p className="more-info-paragraph">Vi setter pris på at du holder notene løpende oppdatert, og
                            vi bistår gjerne.</p>
                    </div>

                    <button className="more-info-headline" onClick={() => {
                        toggleMoreInfoHeadline('partialPublishing')
                    }}>
                        <div>Delpublisere?</div>
                        {moreInfoHeadlinesIsOpen.partialPublishing ?
                            <MdOutlineExpandLess className="more-info-icons"/> :
                            <MdOutlineExpandMore className="more-info-icons"/>
                        }
                    </button>
                    <div
                        className={
                            `more-info-paragraph-container${moreInfoHeadlinesIsOpen.partialPublishing ? ' expanded' : ''}`
                        }
                    >
                        <p className="more-info-paragraph">Du kan gjerne levere fra deg deler av et manus. Ta kontakt
                            med support (
                            <Link className="welcome-text-link" to="mailto:support@karnovgroup.no"
                                  target="_blank">support@karnovgroup.no</Link>
                            ), som bistår med å hente ut de delene som er klare for gjennomgang.</p>
                    </div>
                    <button className="more-info-headline" onClick={() => {
                        toggleMoreInfoHeadline('help')
                    }}>
                        <div>Lurer du på noe?</div>
                        {moreInfoHeadlinesIsOpen.help ?
                            <MdOutlineExpandLess className="more-info-icons"/> :
                            <MdOutlineExpandMore className="more-info-icons"/>
                        }
                    </button>
                    <div
                        className={
                            `more-info-paragraph-container${moreInfoHeadlinesIsOpen.help ? ' expanded' : ''}`
                        }
                    >
                        <p className="more-info-paragraph">Karnovs redaktører og support hjelper deg gjerne. Du er
                            alltid velkommen til å ta kontakt hvis du har
                            spørsmål eller noe du ønsker å drøfte. <Link className="welcome-text-link"
                                                                         to="https://www.karnovgroup.no/om-oss/team"
                                                                         target="_blank">Kontaktinfo finner du her
                            </Link>.
                        </p>
                    </div>
                </div>

            </div>
        </div>
    )
}

type MoreInfoHeadlinesIsOpen = {
    publishNotes: boolean,
    partialPublishing: boolean,
    help: boolean,
}